import { VALID_DURATIONS } from './constants';

export function isValidDuration(val: number) {
  return VALID_DURATIONS.includes(val);
}
